import * as React from 'react';

import { Button } from '../../components/buttons';
import { Checkbox, TextInput } from '../../components/forms';

interface Props {
	className?: string;
	pickListType: PickListType;
	isLoading: boolean;
	handleInputChange: (value?: {}) => void;
	handleSaveClick: (value?: {}) => void;
}
const PickListTypeForm: React.StatelessComponent<Props> = props => {
	return (
		<div className={props.className}>
			<div className="row align-items-end">
				<TextInput
					className="col-lg-4 col-xl-6 mb-lg-0"
					labelText="Description"
					name="description"
					value={props.pickListType.description}
					placeholder="Short description"
					onChange={props.handleInputChange}
				/>
				<Checkbox
					className="col-xs-12 col-lg-auto mb-lg-0 single"
					label={'<strong>Active</strong>'}
					name="isActive"
					checked={props.pickListType.isActive}
					onChange={props.handleInputChange}
				/>
				<div className="col-xs-12 col-lg-auto ml-lg-3">
					<Button className="btn-primary" type="button" disabled={props.isLoading} onClick={props.handleSaveClick}>
						Save
					</Button>
				</div>
			</div>
		</div>
	);
};

export default PickListTypeForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/PickListTypeForm.tsx